export const strings = {
  queueRollover: 'Queue rollover',
  agentTimeout: 'Agent timeout',
  countdownFormat: (seconds: number) => `in ${seconds}s...`,
} as const;

export default strings;
